import { useRef, useState } from 'react';

/**
 * Custom hook to manage dynamic menu width for Select components.
 * This hook provides a ref to attach to the FormControl and handles
 * calculating and storing the menu width when the Select opens.
 * 
 * @returns {Object} An object containing:
 *   - formControlRef: Ref to attach to the FormControl wrapper
 *   - menuWidth: Current calculated width of the menu
 *   - handleMenuOpen: Function to call when the Select opens
 */
export const useMenuWidth = () => {
  const formControlRef = useRef<HTMLDivElement>(null);
  const [menuWidth, setMenuWidth] = useState<number | undefined>(undefined);

  const handleMenuOpen = () => {
    if (formControlRef.current) {
      const width = formControlRef.current.getBoundingClientRect().width;
      setMenuWidth(width);
    }
  };

  return { formControlRef, menuWidth, handleMenuOpen };
};
